const debounce = (func: any, wait: number) => {
    let timeout: ReturnType<typeof setTimeout> | null;

    return function (...args: any) {
        // TODO: Check if this is intentional or has any side effects
        // when using `this` of the above scope.
        /* eslint-disable @typescript-eslint/no-this-alias */
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        const context = this;

        if (timeout) clearTimeout(timeout);

        timeout = setTimeout(() => {
            timeout = null;
            func.apply(context, args);
        }, wait);
    };
};

export default debounce;
